export const imageCarouselGalleryStyles = {
  alpha: {
    slots: {
      buttonStyling: 'bg-brand-secondary-100 ',
      buttonIcon: 'material-symbols-light:animated-images-outline-rounded',
      borderRadius: 'rounded',
    },
  },
  bravo: {
    slots: {
      buttonStyling: 'bg-brand-gray-100',
      buttonIcon: 'material-symbols-light:animated-images-rounded',
      borderRadius: 'rounded',
    },
  },
  charlie: {
    slots: {
      buttonStyling: 'bg-brand-secondary-100 ',
      buttonIcon: 'material-symbols-light:animated-images-rounded',
      borderRadius: 'rounded',
    },
  },
  charlie2: {
    slots: {
      buttonStyling: 'bg-brand-gray-100',
      buttonIcon: 'material-symbols-light:animated-images-rounded',
      borderRadius: '',
    },
  },
}
